var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconEdit48Filled = function SvgIconEdit48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m23.699 15.459-12.15 12.14a1.74 1.74 0 0 0-.46.88l-1.23 6.26a2.89 2.89 0 0 0 3.4 3.4l6.26-1.23c.33-.066.633-.23.87-.47l12.14-12.14-8.83-8.84ZM36.63 12.69l-1.34-1.34a5.31 5.31 0 0 0-7.5 0l-1.71 1.71 8.84 8.84 1.71-1.71a5.31 5.31 0 0 0 0-7.5Z",
    fill: "current"
  })));
};
export default SvgIconEdit48Filled;